import { styled } from '@mui/material/styles';
import { useRef, useState } from 'react';
import Button from '../Button/Button';
import { FormattedMessage } from 'react-intl';
import { DropZone } from '../DropZone/DropZone';

const FileInput = ({
  value,
  onChange,
  children,
  renderContent,
  className,
}: {
  value: File | null;
  onChange: (file: File | null) => void;
  children?: React.ReactNode;
  renderContent?: (fileName: string | null) => React.ReactNode;
  className?: string;
}) => {
  const [file, setFile] = useState<File | null>(value);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (files: FileList | null) => {
    const selectedFile = files?.[0] || null;
    setFile(selectedFile);
    onChange(selectedFile);
  };

  const getButtonContent = () => {
    if (renderContent) {
      return renderContent(file?.name || null);
    }
    if (file) {
      return file.name;
    }
    return (
      children || (
        <FormattedMessage
          id="selectFile"
          defaultMessage="Select a File"
        />
      )
    );
  };

  return (
    <Root>
      <DropZone onFileChange={handleFileChange}>
        <Button
          variant="outlined"
          onClick={() => inputRef.current?.click()}
          fullWidth
          className={className}
          aria-label="Select File Button"
        >
          {getButtonContent()}
        </Button>
        <input
          type="file"
          ref={inputRef}
          onChange={(e) => {
            const selectedFile = e.target.files?.[0] || null;
            setFile(selectedFile);
            onChange(selectedFile);
          }}
        />
      </DropZone>
    </Root>
  );
};

const Root = styled('div')(() => ({
  input: {
    display: 'none',
  },
}));

export default FileInput;
